import { getAPI } from "./Networking";
import {
  OpsAnalyticsData,
  OrdersList,
} from "../models/Dashboard/OpsDashboard/OpsAnalytics";
import {
  AnalyticsGraphResponse,
  LabelValue,
} from "../models/Dashboard/Analytics";
import dayjs from "dayjs";
import { MockupsAnalyticsAPIFilters } from "../models/Dashboard/OpsDashboard/MockupsAnalyticsFilters";

export default class MockupsAnalyticsDashboardAPI {
  getTatsData = async (
    url: string,
    filters: MockupsAnalyticsAPIFilters
  ): Promise<LabelValue[] | AnalyticsGraphResponse[] | OpsAnalyticsData> => {
    try {
      const start_date = dayjs(filters.start_date, "YYYY-MM-DD")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const end_date = dayjs(filters.end_date, "YYYY-MM-DD")
        .add(1, "day")
        .utc()
        .format("YYYY-MM-DD HH:mm:ss");

      const queryParams = new URLSearchParams();

      if (start_date) queryParams.append("start_date", start_date);

      if (end_date) queryParams.append("end_date", end_date);

      if (filters.order_id && filters.order_id.length > 0) {
        queryParams.append(
          "order_id",
          filters.order_id.map((item) => item.id).join(",")
        );
      }

      if (filters.customer_id && filters.customer_id.length > 0) {
        queryParams.append(
          "customer_id",
          filters.customer_id.map((item) => item.id).join(",")
        );
      }

      if (filters.admin_id && filters.admin_id.length > 0) {
        queryParams.append(
          "admin_id",
          filters.admin_id.map((item) => item.id).join(",")
        );
      }

      if (filters.order_type && filters.order_type.length > 0) {
        queryParams.append(
          "order_type",
          filters.order_type.map((item) => item.id).join(",")
        );
      }

      // if (filters.excluded_orders) {
      //   queryParams.append(
      //     "excluded_orders",
      //     filters.excluded_orders.toString()
      //   );
      // }

      if (filters.mockup_time) {
        queryParams.append("mockup_time", filters.mockup_time.toString());
      }

      const response = await getAPI(
        `/v5/ops-analytics/mockups${url}?${queryParams.toString()}`
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };
}
